/**
 * PATH: apps/hr/src/pages/settings/DocumentAlertPoliciesPage.tsx
 * PURPOSE: HR document alert policies (real-data only)
 *
 * WHY:
 * - The previous implementation used mock alert policies.
 * - Alert policies are not yet backed by a real HR API in this hub.
 */

import { Bell } from 'lucide-react'
import { EmptyState } from '../../components/ui/EmptyState'

export function DocumentAlertPoliciesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">Alert Policies</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
          Configure expiry alerts and notifications.
        </p>
      </div>

      <EmptyState
        icon={Bell}
        title="Alert policies not connected"
        description="This page has been cleaned up to remove dummy data. Once an alerts policy API is available for HR Hub, configuration will appear here."
      />
    </div>
  )
}

export default DocumentAlertPoliciesPage

